import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import InfoTooltip from '../InfoTooltip';
import imageCompression from 'browser-image-compression';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import {
  createCategory,
  createDoorList,
  getAllLuggage,
  getBnbList,
  updateDoorlist,
  updateLuggageDoorlist,
  uploadFile,
} from '../../helper/backend_helper';
import appConfig from '../../config';

const UpdateLuggageDoor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;

  const [formData, setFormData] = useState({ profileImage: null });
  const [doorName, setDoorName] = useState(userData?.doorName);
  const [bnb, setBnB] = useState(userData?.bnb);
  const [script, setScript] = useState(userData?.scriptOrCode);
  const [value, setValue] = useState(userData?.value);
  const [deviceId, setDeviceId] = useState(userData?.deviceId);
  const [description, setDescription] = useState(userData?.description);
  const [number, setNumber] = useState(userData?.number);
  const [loading, setLoading] = useState(false);
  const [italiandoorName, setItalianDoorName] = useState(userData?.italiandoorName);
  const [italianDescription, setItalianDescription] = useState(userData?.italianDescription);
  const [luggageBnB, setLuggageBnB] = useState(userData?.luggageBnB);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [luggage, setLuggage] = useState([]);
  async function fetchLuggageData() {
    try {
      const usersResponse = await getAllLuggage();
      const filtredLuggage = usersResponse?.data?.data?.filter((item) => item.bnbType === 'entered');
      setLuggage(filtredLuggage);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(usersResponse?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
    fetchLuggageData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);
      if (!doorName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Door Name is required',
        });
        setLoading(false);
        return;
      }

      // if (!bnb) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Error',
      //     text: 'BnB Name is required',
      //   });
      //   setLoading(false);
      //   return;
      // }

      if (!script) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Script is required',
        });
        setLoading(false);
        return;
      }

      if (!luggageBnB) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Storage name is required',
        });
        setLoading(false);
        return;
      }

      if (!value) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Value is required',
        });
        setLoading(false);
        return;
      }

      if (!description) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Description is required',
        });
        setLoading(false);
        return;
      }
      if (!number) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Number is required',
        });
        setLoading(false);
        return;
      }
      if (!italiandoorName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Door Name is required',
        });
        setLoading(false);
        return;
      }

      if (!italianDescription) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Description is required',
        });
        setLoading(false);
        return;
      }
      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      let imageUploadResponse; // Declare it outside the block

      if (formData.profileImage) {
        const originalFile = formData.profileImage;

        // Log original file size
        console.log('Original file size:', (originalFile.size / 1024).toFixed(2), 'KB');

        // Compression options
        const options = {
          maxSizeMB: 0.3, // Compress to a maximum of 0.5 MB
          maxWidthOrHeight: 800, // Restrict dimensions to 800px
          useWebWorker: true, // Use web worker for performance
          initialQuality: 0.6, // Reduce starting quality to 60%
        };

        // Compress image
        const compressedFile = await imageCompression(originalFile, options);

        // Log compressed file size
        console.log('Compressed file size:', (compressedFile.size / 1024).toFixed(2), 'KB');

        const data = new FormData();
        data.append('file', compressedFile);

        imageUploadResponse = await uploadFile(data, headers); // Assign value inside the block
        console.log(imageUploadResponse?.data?.data?.fileName);

        if (imageUploadResponse.status !== 200) {
          throw new Error('Image upload failed');
        }
      }

      // Build the Categorydata object
      const Categorydata = {
        photo: imageUploadResponse?.data?.data?.fileName || userData?.photo, // Use the uploaded image or fallback
        description,
        scriptOrCode: script,
        doorName,
        bnb,
        value,
        number,
        deviceId,
        italiandoorName,
        italianDescription,
        luggageBnB,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateLuggageDoorlist(userData?._id, Categorydata, Categoryheaders);

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Door List updated successfully',
      });
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> door list </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Luggage Door List</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Boor Name <InfoTooltip title="English name of this door or access point as guests will see it in their entry instructions." /></FormLabel>
              <TextField
                label="Enter Door Name"
                id="outlined-size-small"
                value={doorName}
                onChange={(e) => setDoorName(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Italian Door Name <InfoTooltip title="Italian name for this door, shown to guests who view their instructions in Italian." /></FormLabel>
              <TextField
                label="Enter Italian Door Name"
                id="outlined-size-small"
                value={italiandoorName}
                onChange={(e) => setItalianDoorName(e.target.value)}
              />
            </Stack>
            {/* <Stack>
              <FormLabel sx={{ mb: 1 }}>Script</FormLabel>
              <TextField
                label="Enter Script"
                id="outlined-size-small"
                value={script}
                onChange={(e) => setScript(e.target.value)}
              />
            </Stack> */}

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>Script <InfoTooltip title="How the door is opened: a remote-open Script, a physical Lockbox, or a Script plus doorbell." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={script}
                  // label="BnB"
                  onChange={(e) => setScript(e.target.value)}
                >
                  <MenuItem value="Script">Script</MenuItem>
                  <MenuItem value="Lockbox">Lockbox</MenuItem>
                  <MenuItem value="Script + Doorbell">Script + Doorbell</MenuItem>
                  {/* {users?.map((user) => (
                    <MenuItem key={user._id} value={user.BnBShortName}>
                      {user.BnBShortName}
                    </MenuItem>
                  ))} */}
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Script value/Keybox code <InfoTooltip title="The actual code or value used to open the door: the keybox PIN or the script identifier." /></FormLabel>
              <TextField
                label="Enter Script Name"
                id="outlined-size-small"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Device ID / Phone Number <InfoTooltip title="Identifier of the smart-lock device or the phone number used to trigger remote door opening." /></FormLabel>
              <TextField
                label="Enter Device ID / Phone Number"
                id="outlined-size-small"
                value={deviceId}
                onChange={(e) => setDeviceId(e.target.value)}
              />
            </Stack>

            {/* <Stack>
            <FormControl sx={{ width: 490 }}>
              <FormLabel sx={{ mb: 1 }}>BnB</FormLabel>
              <Select
                labelId="demo-multi-select-label"
                id="demo-multi-select"
                multiple
                value={bnb} // This will be an array
                onChange={(e) => setBnB(e.target.value)}
                renderValue={(selected) => selected.join(', ')} // Render selected values as a comma-separated string
              >
                {users?.map((user) => (
                  <MenuItem key={user._id} value={user.BnBShortName}>
                    <Checkbox checked={bnb.indexOf(user.BnBShortName) > -1} />
                    {user.BnBShortName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            </Stack> */}

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Sequence Number <InfoTooltip title="Order in which this door appears in the guest entry steps; lower numbers are shown first." /></FormLabel>
              <TextField
                type="number"
                label="Enter Sequence Number"
                id="outlined-size-small"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
              />
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormControl sx={{ width: { xs: '100%', sm: 490 } }}>
                <FormLabel sx={{ mb: 1 }}>Select Luggage BnB <InfoTooltip title="The luggage storage point this door belongs to; links these access instructions to that storage." /></FormLabel>
                {/* <InputLabel id="demo-simple-select-label">BnB</InputLabel> */}
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={luggageBnB}
                  onChange={(e) => setLuggageBnB(e.target.value)}
                >
                  {luggage?.map((user) => (
                    <MenuItem key={user._id} value={user.storageName}>
                      {user.storageName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Description <InfoTooltip title="Step-by-step English instructions explaining how to open this door or retrieve the keys." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Description"
                id="outlined-size-small"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Stack>

            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Italian Description <InfoTooltip title="Italian version of the door-opening instructions, shown to guests using the app in Italian." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Italian Description"
                id="outlined-size-small"
                value={italianDescription}
                onChange={(e) => setItalianDescription(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {!formData.profileImage ? (
                <img
                  src={`${appConfig.FILE_URL}${userData?.photo}`}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              ) : (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateLuggageDoor;
